<header class="header">
  <img src="https://mauserpackaging.com/wp-content/uploads/2024/11/Mauser_h_RGB.png" alt="Noreko logo" class="noreko-logo-desktop">
  <div class="header-container">
    <div class="logo-container">
      <img src="https://mauserpackaging.com/wp-content/uploads/2024/11/Mauser_h_RGB.png" alt="Noreko logo" class="noreko-logo-mobile">
      <!--<span class="logo-text">
        mauser<span class="logo-db"><span class="logo-d">D</span>B</span>
      </span>-->
    </div>
    <div class="header-actions">
      <ng-content></ng-content>
    </div>
  </div>
</header>
